export const ComputerTechnology = [
    {
        title: "View All",
        path: "/shop",
        cls: 'md:px-4'
    },
];


export const NewProductOffer = [
    {
        title: "View All",
        path: "/shop",
        cls: 'md:px-4'
    },
     
];

export const MostViewedProduct = [
    {
        title: "View All",
        path: "/shop",
        cls: 'md:px-4'
    },
     
];


export const FeaturedProducts = [
    {
        title: "View All",
        path: "/shop",
        cls: 'md:px-4'
    },
     
];
